(ns machtfit.stepchall.subs
  (:require [clojure.string :as str]
            [machtfit.stepchall.catmullrom :as catmullrom]
            [medley.core :refer [map-vals]]
            [re-frame.core :as rf]))

(rf/reg-sub ::is-team-member?
  :<- [:get [:stepchall :team]]

  (fn [team _]
    (some? team)))

(rf/reg-sub ::is-spectator?
  :<- [::in-team-building-phase?]
  :<- [::is-team-member?]

  (fn [[in-team-building-phase? is-team-member?] _]
    (and (not is-team-member?) (not in-team-building-phase?))))

(rf/reg-sub ::teams-by-id
  :<- [:get [:stepchall :teams]]

  (fn [teams _]
    (->> teams
         (group-by :id)
         (map-vals first))))

(defn- mark-my-team [my-team-id team]
  (cond-> team
    (= (:id team) my-team-id) (assoc :my-team? true)))

(defn- add-position [catmullrom-curve leg-lengths goal item->position item]
  (merge item (catmullrom/point-on-curve catmullrom-curve leg-lengths (/ (item->position item) goal))))

(rf/reg-sub ::catmullrom-curve
  :<- [:get [:stepchall :theme :path]]

  (fn [path _]
    (catmullrom/catmullrom path)))

(rf/reg-sub ::path-leg-lengths
  :<- [:get [:stepchall :theme :path]]

  (fn [path _]
    (catmullrom/path->leg-lengths path)))

(rf/reg-sub ::teams
  :<- [:get [:stepchall :team :id]]
  :<- [:get [:stepchall :teams]]
  :<- [:get [:stepchall :goal]]
  :<- [::catmullrom-curve]
  :<- [::path-leg-lengths]

  (fn [[my-team-id all-teams goal catmullrom-curve leg-lengths] _]
    (->> all-teams
         (map (partial mark-my-team my-team-id))
         (map (partial add-position catmullrom-curve leg-lengths goal #(-> % :step-counts :total))))))

(defn prepare-stages [stages goal catmullrom-curve leg-lengths]
  (->> stages
       (map (partial add-position catmullrom-curve leg-lengths goal :num-steps))
       (map #(cond-> %
               (= 0 (:num-steps %)) (assoc :is-start? true)
               (= goal (:num-steps %)) (assoc :is-goal? true)))))

(rf/reg-sub ::stages
  :<- [:get [:stepchall :stages]]
  :<- [:get [:stepchall :goal]]
  :<- [::catmullrom-curve]
  :<- [::path-leg-lengths]

  (fn [[stages goal catmullrom-curve leg-lengths] _]
    (prepare-stages stages goal catmullrom-curve leg-lengths)))

(rf/reg-sub ::activity-data
  :<- [:get [:stepchall :activities]]
  :<- [:get [:stepchall :activity-units]]
  :<- [:get [:stepchall :main-unit :plural]]

  (fn [[activities activity-units main-unit-plural] [_ key]]
    (get (merge activity-units
                activities
                {:steps {:name main-unit-plural
                         :unit :steps}})
         key)))

(rf/reg-sub ::unit-name
  :<- [:get [:stepchall :activity-units]]
  :<- [:get [:stepchall :main-unit :plural]]

  (fn [[unit-names main-unit-plural] [_ unit]]
    (cond-> (unit unit-names)
      (= unit :steps) (merge main-unit-plural))))

(rf/reg-sub ::challenge-started?
  :<- [:get [:clock :current-server-time]]
  :<- [:get [:stepchall :challenge-start]]

  (fn [[current-time challenge-start] _]
    (> current-time challenge-start)))

(rf/reg-sub ::count-teams
  :<- [:get [:stepchall :teams]]

  (fn [teams _]
    (count teams)))

(rf/reg-sub ::in-team-building-phase?
  :<- [:get [:clock :current-server-time]]
  :<- [:get [:stepchall :team-building-end]]

  (fn [[current-time team-building-end] _]
    (< current-time team-building-end)))

(rf/reg-sub ::members-for-team
  :<- [:get [:stepchall :participants]]
  :<- [:get [:stepchall :loaded-participants]]
  :<- [:get [:ui :page :team-id]]

  (fn [[participants loaded-participants team-id] _]
    (cond
      (= loaded-participants :all) (filter #(= (:team-id %) team-id) participants)
      (= loaded-participants team-id) participants)))

(rf/reg-sub ::steps-as-main-unit?
  :<- [:get [:stepchall :main-unit]]

  (fn [{:keys [singular]} _]
    (-> singular :en str/lower-case (= "step"))))
